import { render, staticRenderFns } from "./BigQueryAuthenticationDetails.vue?vue&type=template&id=7fd16b08&"
import script from "./BigQueryAuthenticationDetails.vue?vue&type=script&lang=ts&"
export * from "./BigQueryAuthenticationDetails.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports